/**
 * @generated SignedSource<<873628039c15edbcc6a084575a146a8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorByLineFragment_content$data = Result<{
  readonly bylineClassificationFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
  } | null;
  readonly contentProperties: {
    readonly latest: {
      readonly generatedBy: string | null;
    } | null;
  } | null;
  readonly history: {
    readonly createdBy: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null;
    readonly ownedBy: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly space: {
    readonly id: string | null;
    readonly name: string | null;
  } | null;
  readonly type: string | null;
  readonly version: {
    readonly number: number | null;
    readonly when: string | null;
  } | null;
  readonly " $fragmentType": "useEditorByLineFragment_content";
}, unknown>;
export type useEditorByLineFragment_content$key = {
  readonly " $data"?: useEditorByLineFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorByLineFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ],
    "type": "KnownUser"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "profilePicture",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "path"
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeClassification"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useClassificationLevelV2"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorByLineFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "name": "ownedBy",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ]
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        },
        {
          "kind": "ScalarField",
          "name": "when"
        }
      ]
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "generatedBy"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "condition": "includeClassification",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "useClassificationLevelV2",
                    "variableName": "useClassificationLevelV2"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "BylineClassification_content"
              }
            ],
            "type": "Content"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "bylineClassificationFragment"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "c78c99675db394da49e74603f143bf9b";

export default node;
